import { HealthStatus, TimeoutCheckResult, ValidatedDependencyCheck } from './types/HealthProbeTypes'

export const validateDependencyChecks = (
    dependencyChecks: [PromiseSettledResult<TimeoutCheckResult>],
): ValidatedDependencyCheck => {
    const dependencies = dependencyChecks.map((result) => {
        // checkWithTimeout always resolves (never rejects) due to its try/catch wrapper,
        // so result.status will always be 'fulfilled'. This is defensive programming.
        if (result.status === 'fulfilled') {
            return {
                name: result.value.name,
                status: result.value.status,
                message: result.value.message,
                responseTime: result.value.responseTime,
                ...(result.value.error && { error: result.value.error }),
            }
        }

        // This should never happen in practice, but kept as a safety net
        // in case checkWithTimeout implementation changes in the future
        return {
            name: 'Unknown',
            status: HealthStatus.UNHEALTHY,
            message: 'Check failed unexpectedly',
            error: result.reason?.message || 'Unknown error',
        }
    })

    const overallHealthStatus = dependencies.every((dependency) => dependency.status === HealthStatus.HEALTHY)
        ? HealthStatus.HEALTHY
        : HealthStatus.UNHEALTHY

    return {
        overallHealthStatus,
        dependencies,
    }
}
